import { render } from "./PopoverCategoryView.vue?vue&type=template&id=d9df0492&scoped=true"
import script from "./PopoverCategoryView.vue?vue&type=script&lang=js"
export * from "./PopoverCategoryView.vue?vue&type=script&lang=js"

import "./PopoverCategoryView.vue?vue&type=style&index=0&id=d9df0492&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9df0492"]])

export default __exports__